import type { BadgeProps } from '@radix-ui/themes'
import { Ops } from '@willie/schemas'
import { compatibilityStatusColor, meterCompatibilityLabel } from '~/features/installations/constants'
import type { TRPCOutputs } from '~/utils/trpc'

export type ReviewItem = TRPCOutputs['ops']['compatibilityReview']['list'][number]
export type MeterPhoto = TRPCOutputs['ops']['compatibilityReview']['photos'][number]
export type SuggestionFields = Pick<
  ReviewItem,
  | 'installation_id'
  | 'suggested_compatibility'
  | 'suggested_meter_maker'
  | 'suggested_meter_model'
  | 'suggested_comment'
  | 'suggested_at'
  | 'suggestion_failed_at'
>

type SuggestedCompatibility = Ops.MeterPhotos.SuggestedCompatibility

export const suggestedCompatibilityLabel: Record<SuggestedCompatibility, string> = {
  compatible: meterCompatibilityLabel.compatible,
  not_compatible: meterCompatibilityLabel.not_compatible,
  unsure: 'Unsure'
}

export const suggestedCompatibilityColor: Record<SuggestedCompatibility, BadgeProps['color']> = {
  compatible: compatibilityStatusColor.compatible_supported,
  not_compatible: compatibilityStatusColor.not_compatible,
  unsure: 'amber'
}

// suggested_compatibility is checked by Postgres but typed as text; anything else shows as unsure.
export const toSuggestedCompatibility = (value: string | null): SuggestedCompatibility | null =>
  value === null ? null : (Ops.MeterPhotos.suggestedCompatibilitySchema.safeParse(value).data ?? 'unsure')
